export const NONE_LICENSE_VALUE = "__none__";

export type UserWithLicense = {
    isAdmin: boolean;
    isLastAdmin: boolean;
    isMonthlyAnalyzedMailLimitReached: boolean;
    licenseId?: string;
    userId: string;
    userMail: string | null;
};
